<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div
              class="card-header card-header-primary negative blue-grad w-50"
            >
              <h4 class="card-title">{{ $t("message.menu.account") }}</h4>
            </div>
            <div class="card-body px-3">
              <h2>{{ $t("message.reg_form.company_data") }}</h2>
              <span
                :class="[
                  'bmd-form-group mb-2 d-block form-label-group required',
                  $v.organization.org_code.$error
                    ? 'has-danger label-floating'
                    : '',
                ]"
              >
                <cleave
                  v-model="organization.org_code"
                  :options="cleave_12_digits"
                  class="form-control"
                  :placeholder="$t('message.reg_form.company_id')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="company_id"
                ></cleave>
                <label for="company_id" class="form-label-group-label">{{
                  $t("message.reg_form.company_id")
                }}</label>
                <label
                  v-if="!$v.organization.org_code.required"
                  class="control-label text-danger"
                  >{{ $t("message.errors.required") }}</label
                >
                <label
                  v-if="!$v.organization.org_code.minLength"
                  class="control-label text-danger"
                  >{{ $t("message.errors.min_length") }}</label
                >
                <label
                  v-if="!$v.organization.org_code.maxLength"
                  class="control-label text-danger"
                  >{{ $t("message.errors.max_length") }}</label
                >
                <label
                  v-if="!$v.organization.org_code.integer"
                  class="control-label text-danger"
                  >{{ $t("message.errors.integer") }}</label
                >
              </span>
              <span
                :class="[
                  'bmd-form-group mb-2 d-block form-label-group required',
                  $v.organization.org_name.$error
                    ? 'has-danger label-floating'
                    : '',
                ]"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="organization.org_name"
                  :placeholder="$t('message.reg_form.company_title')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="company_title"
                  @blur="validateField('company_title')"
                />
                <label for="company_title" class="form-label-group-label">{{
                  $t("message.reg_form.company_title")
                }}</label>
                <label
                  v-if="!$v.organization.org_name.required"
                  class="control-label text-danger"
                  >{{ $t("message.errors.required") }}</label
                >
              </span>
              <span
                :class="[
                  'bmd-form-group mb-2 d-block form-label-group required',
                  placeholder_oked ? 'placeholderStatus' : '',
                  $v.organization.org_oked.$error
                    ? 'has-danger label-floating'
                    : '',
                  oked_focused ? 'focused' : '',
                ]"
              >
                <v-select-popup
                  type="oked"
                  v-model="organization.org_oked"
                  :placeholder="$t('message.reg_form.company_oked')"
                />
                <!-- <v-select :options="okeds" label="display_text" :class="['form-control', organization.org_oked!==''?'vs--selected':'']" @search="fetchOkeds" v-model="organization.org_oked" :placeholder="$t('message.reg_form.company_oked')" @focus="okedsFocused" @blur="okedsBlurred"></v-select>
								<label for="company_oked" class="form-label-group-label shorter">{{$t('message.reg_form.company_oked')}}</label> -->
                <label
                  v-if="!$v.organization.org_oked.required"
                  class="control-label text-danger"
                  >{{ $t("message.errors.required") }}</label
                >
              </span>
              <span :class="['bmd-form-group mb-2 d-block']">
                <!-- <b-form-datepicker :locale="locale" v-model="organization.org_reg_date" :placeholder="$t('message.reg_form.company_regdate')" size="sm" no-flip :hide-header="true" :show-decade-nav="false"></b-form-datepicker> -->

                <datepicker
                  @focus="organization.org_reg_date = ' '"
                  value-type="YYYY-MM-DD"
                  format="DD.MM.YYYY"
                  @blur="
                    organization.org_reg_date == ' '
                      ? (organization.org_reg_date = '')
                      : (organization.org_reg_date = organization.org_reg_date)
                  "
                  inputClass="form-control"
                  :disabled="is_field_readonly"
                  v-model="organization.org_reg_date"
                  :placeholder="$t('message.reg_form.company_regdate')"
                  :inputAttr="{ id: 'company_regdate' }"
                />
                <label
                  for="company_regdate"
                  class="form-label-group-label shorter"
                  :class="
                    organization.org_reg_date != '' &&
                    organization.org_reg_date != null
                      ? 'topped'
                      : ''
                  "
                  >{{ $t("message.reg_form.company_regdate") }}</label
                >
              </span>
              <span :class="['bmd-form-group mb-2 d-block form-label-group']">
                <input
                  type="text"
                  class="form-control"
                  v-model="organization.company_region"
                  :placeholder="$t('message.reg_form.company_region')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="company_region"
                />
                <label for="company_region" class="form-label-group-label">{{
                  $t("message.reg_form.company_region")
                }}</label>
              </span>
              <span :class="['bmd-form-group mb-2 d-block form-label-group']">
                <input
                  type="text"
                  class="form-control"
                  v-model="organization.company_contacts"
                  :placeholder="$t('message.reg_form.company_contacts')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="company_contacts"
                />
                <label for="company_contacts" class="form-label-group-label">{{
                  $t("message.reg_form.company_contacts")
                }}</label>
              </span>
              <span :class="['bmd-form-group mb-2 d-block form-label-group']">
                <input
                  type="text"
                  class="form-control"
                  v-model="organization.company_main_sphere"
                  :placeholder="$t('message.reg_form.company_main_sphere')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="company_main_sphere"
                />
                <label
                  for="company_main_sphere"
                  class="form-label-group-label"
                  >{{ $t("message.reg_form.company_main_sphere") }}</label
                >
              </span>
              <span :class="['bmd-form-group mb-2 d-block form-label-group']">
                <input
                  type="text"
                  class="form-control"
                  v-model="organization.company_additional_sphere"
                  :placeholder="
                    $t('message.reg_form.company_additional_sphere')
                  "
                  autocomplete="off"
                  style="cursor: auto"
                  id="company_additional_sphere"
                />
                <label
                  for="company_additional_sphere"
                  class="form-label-group-label"
                  >{{ $t("message.reg_form.company_additional_sphere") }}</label
                >
              </span>
              <span :class="['bmd-form-group mb-2 d-block  form-label-group']">
                <input
                  type="text"
                  class="form-control"
                  v-model="organization.company_ceo"
                  :placeholder="$t('message.reg_form.company_ceo')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="company_ceo"
                />
                <label for="company_ceo" class="form-label-group-label">{{
                  $t("message.reg_form.company_ceo")
                }}</label>
              </span>
              <span :class="['bmd-form-group mb-2 d-block form-label-group']">
                <input
                  type="text"
                  class="form-control"
                  v-model="organization.company_founder"
                  :placeholder="$t('message.reg_form.company_founder')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="company_founder"
                />
                <label for="company_founder" class="form-label-group-label">{{
                  $t("message.reg_form.company_founder")
                }}</label>
              </span>
              <span :class="['bmd-form-group mb-2 d-block form-label-group']">
                <input
                  type="text"
                  class="form-control"
                  v-model="organization.company_website"
                  :placeholder="$t('message.reg_form.company_website')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="company_website"
                  @blur="validateField('company_website')"
                />
                <label for="company_website" class="form-label-group-label">{{
                  $t("message.reg_form.company_website")
                }}</label>
              </span>
              <h2>{{ person.given_name }} {{ person.last_name }}</h2>
              <span
                :class="[
                  'bmd-form-group mb-2 d-block form-label-group required',
                  $v.person.person_code.$error
                    ? 'has-danger label-floating'
                    : '',
                ]"
              >
                <cleave
                  v-model="person.person_code"
                  id="customer_id"
                  :options="cleave_12_digits"
                  class="form-control"
                  :placeholder="$t('message.reg_form.customer_id')"
                  @blur="validateField('customer_id')"
                  autocomplete="off"
                  style="cursor: auto"
                ></cleave>
                <label for="customer_id" class="form-label-group-label">{{
                  $t("message.reg_form.customer_id")
                }}</label>
                <label
                  v-if="!$v.person.person_code.required"
                  class="control-label text-danger"
                  >{{ $t("message.errors.required") }}</label
                >
                <label
                  v-if="!$v.person.person_code.minLength"
                  class="control-label text-danger"
                  >{{ $t("message.errors.min_length") }}</label
                >
                <label
                  v-if="!$v.person.person_code.maxLength"
                  class="control-label text-danger"
                  >{{ $t("message.errors.max_length") }}</label
                >
                <label
                  v-if="!$v.person.person_code.integer"
                  class="control-label text-danger"
                  >{{ $t("message.errors.integer") }}</label
                >
              </span>
              <span
                :class="[
                  'bmd-form-group mb-2 d-block form-label-group required',
                  $v.person.last_name.$error ? 'has-danger label-floating' : '',
                ]"
              >
                <input
                  type="text"
                  class="form-control"
                  @blur="validateField('customer_last_name')"
                  v-model="person.last_name"
                  :placeholder="$t('message.reg_form.customer_last_name')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="customer_last_name"
                />
                <label
                  for="customer_last_name"
                  class="form-label-group-label"
                  >{{ $t("message.reg_form.customer_last_name") }}</label
                >
                <label
                  v-if="!$v.person.last_name.required"
                  class="control-label text-danger"
                  >{{ $t("message.errors.required") }}</label
                >
                <label
                  v-if="!$v.person.last_name.alpha"
                  class="control-label text-danger"
                  >{{ $t("message.errors.alpha") }}</label
                >
              </span>
              <span
                :class="[
                  'bmd-form-group mb-2 d-block form-label-group required',
                  $v.person.given_name.$error
                    ? 'has-danger label-floating'
                    : '',
                ]"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="person.given_name"
                  :placeholder="$t('message.reg_form.customer_first_name')"
                  @blur="validateField('customer_first_name')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="customer_first_name"
                />
                <label
                  for="customer_first_name"
                  class="form-label-group-label"
                  >{{ $t("message.reg_form.customer_first_name") }}</label
                >
                <label
                  v-if="!$v.person.given_name.required"
                  class="control-label text-danger"
                  >{{ $t("message.errors.required") }}</label
                >
                <label
                  v-if="!$v.person.given_name.alpha"
                  class="control-label text-danger"
                  >{{ $t("message.errors.alpha") }}</label
                >
              </span>
              <span
                :class="[
                  'bmd-form-group mb-2 d-block form-label-group ',
                  $v.person.middle_name.$error
                    ? 'has-danger label-floating'
                    : '',
                ]"
              >
                <input
                  type="text"
                  class="form-control"
                  v-model="person.middle_name"
                  :placeholder="$t('message.reg_form.customer_middlename')"
                  autocomplete="off"
                  style="cursor: auto"
                  id="customer_middlename"
                  @blur="validateField('customer_first_name')"
                />
                <label
                  for="customer_middlename"
                  class="form-label-group-label"
                  >{{ $t("message.reg_form.customer_middlename") }}</label
                >
                <label
                  v-if="!$v.person.middle_name.alpha"
                  class="control-label text-danger"
                  >{{ $t("message.errors.alpha") }}</label
                >
              </span>
              <div class="row justify-content-between">
                <div class="col-md-6">
                  <span
                    :class="[
                      'bmd-form-group mb-2 d-block form-label-group required',
                      $v.person.date_of_birth.$error
                        ? 'has-danger label-floating'
                        : '',
                    ]"
                  >
                    <!-- <b-form-datepicker :locale="locale" v-model="person.date_of_birth" :placeholder="$t('message.reg_form.customer_birthdate')" size="sm" no-flip :hide-header="true" :show-decade-nav="false" id="customer_birthdate"></b-form-datepicker>
										<label v-if="form_error && !$v.person.date_of_birth.required" class="control-label text-danger">{{$t('message.errors.required')}}</label> -->

                    <datepicker
                      @focus="person.date_of_birth = ' '"
                      value-type="YYYY-MM-DD"
                      format="DD.MM.YYYY"
                      @blur="
                        person.date_of_birth == ' '
                          ? (person.date_of_birth = '')
                          : (person.date_of_birth = person.date_of_birth)
                      "
                      inputClass="form-control"
                      :disabled="is_field_readonly"
                      v-model="person.date_of_birth"
                      :placeholder="$t('message.reg_form.customer_birthdate')"
                      :inputAttr="{ id: 'customer_birthdate' }"
                    />
                    <label
                      for="customer_birthdate"
                      class="form-label-group-label shorter"
                      :class="
                        person.date_of_birth != '' &&
                        person.date_of_birth != null
                          ? 'topped'
                          : ''
                      "
                      >{{ $t("message.reg_form.customer_birthdate") }}</label
                    >
                    <label
                      v-if="form_error && !$v.person.date_of_birth.required"
                      class="control-label text-danger"
                      >{{ $t("message.errors.required") }}</label
                    >
                  </span>
                </div>
                <div class="col-md-5">
                  <div class="togglebutton mt-md-3 form-label-group required">
                    <label class="control-label-sm">
                      <span>{{ $t("message.reg_form.customer_gender") }}</span
                      ><br /><br />
                      <input type="checkbox" v-model="person.gender" />
                      <span class="toggle"></span>
                      <span class="female">{{
                        $t("message.reg_form.customer_female")
                      }}</span>
                      <span class="male">{{
                        $t("message.reg_form.customer_male")
                      }}</span>
                    </label>
                  </div>
                </div>
              </div>

              <button class="btn btn-success" @click="save">
                {{ $t("message.save") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
var querystring = require("querystring");
import moment from "moment";
import {
  required,
  minLength,
  maxLength,
  email,
  url,
  integer,
} from "vuelidate/lib/validators";
export default {
  data() {
    return {
      organization: {},
      person: {},
      residency: {},
      form_error: false,
      placeholder_oked: false,
      oked_focused: false,
      cleave_12_digits: {
        numeral: false,
        numericOnly: true,
        numeralDecimalScale: 0,
        numeralPositiveOnly: true,
        blocks: [12],
      },
      okeds: [],
    };
  },
  mounted() {
    this.load();
    this.fetchOkeds("");
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
  },
  methods: {
    getLibrary(type, query, qty) {
      if (!this.bin_selected) {
        query = query.toLowerCase();
        axios
          .get(
            window.base +
              "/library?type=" +
              type +
              "&query=" +
              query +
              "&qty=" +
              qty +
              "&lang=" +
              this.$i18n.locale,
          )
          .then((response) => {
            if (!this.bin_selected) {
              this.$data[type + (type[type.length - 1] == "s" ? "es" : "s")] =
                response.data;
            }
          });
      }
    },
    fetchOkeds(search, loading) {
      this.getLibrary("oked", search, 100);
    },
    okedsFocused() {
      this.oked_focused = true;
    },
    okedsBlurred() {
      this.oked_focused = false;
      // this.validateField('company_oked')
    },
    save() {
      let tmp = this.organization;
      if (
        typeof tmp.org_oked !== "undefined" &&
        typeof tmp.org_oked.value !== "undefined"
      )
        tmp.org_oked = tmp.org_oked.value;
      axios
        .post(
          window.base + "/document/saveFirmFull",
          querystring.stringify(tmp) + "&" + querystring.stringify(this.person),
        )
        .then((response) => {
          this.$router.push({ name: "account" });
        });
    },
    load() {
      axios.get(window.base + "/document/getfirmfull").then((response) => {
        this.organization = response.data.organizations;
        this.organization.org_reg_date = this.momentum(
          this.organization.org_reg_date,
        );
        this.person = response.data.persons;
        this.person.gender = parseInt(this.person.gender);
        this.person.date_of_birth = this.momentum(this.person.date_of_birth);
        this.residency = response.data.org_residency;
      });
    },
    momentum(dt) {
      var m = moment(dt).format("YYYY-MM-D");
      return m;
    },
    gender(gender) {
      return gender == 0
        ? this.$t("message.account.male")
        : this.$t("message.account.female");
    },
  },
  validations: {
    organization: {
      org_code: {
        required,
        minLength: minLength(12),
        maxLength: maxLength(12),
        integer,
      },
      org_name: {
        required,
      },
      org_oked: {
        required,
      },
      // company_website: {
      // 	url
      // }
    },
    person: {
      person_code: {
        required,
        minLength: minLength(12),
        maxLength: maxLength(12),
        integer,
      },
      last_name: {
        required,
        alpha: (val) => /^[а-яёa-z]*$/i.test(val),
      },
      middle_name: {
        alpha: (val) => /^[а-яёa-z]*$/i.test(val),
      },
      given_name: {
        required,
        alpha: (val) => /^[а-яёa-z]*$/i.test(val),
      },
      date_of_birth: {
        required,
      },
    },
    /*pull: {
				customer_id: {
					required,
					minLength: minLength(12),
					maxLength: maxLength(12),
					integer
				},
				customer_last_name: {
					required,
					alpha: val => /^[а-яёa-z]*$/i.test(val),
				},
				customer_first_name: {
					required,
					alpha: val => /^[а-яёa-z]*$/i.test(val),
				},
				customer_middlename: {
					alpha: val => /^[а-яёa-z]*$/i.test(val),
				},
				customer_email: {
					required,
					email
				},
				customer_password: {
					required,
					password: val => /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&,\.])[A-Za-z\d@$!%*#?&,\.]+$/.test(val),
				},
				customer_birthdate: {
					required,

				},
				customer_address: {
					required,

				},
				customer_position: {
					required,

				},
				customer_phone: {
					required,

				},
				customer_gender: {
					required,

				},
				company_id: {
					required,
					minLength: minLength(12),
					maxLength: maxLength(12),
					integer
				},
				company_title: {
					required,

				},
				company_regdate: {

				},
				company_status: {
					required,

				},
				company_reregdate: {
				},
				company_oked: {
					required,
				},
				company_region: {
				},
				company_main_sphere: {
				},
				company_ceo: {
				},
				company_ceo_date: {
				},
				company_founder: {
				},
				company_number_of_founders: {

				},
				company_website: {
					url
				},
				company_address: {
					required,
				},
				company_accept: {
					required,
				},
			},*/
  },
};
</script>
